export const checksColumnsData = [
    {
        value: 'Numéro de chéque',
    },
    {
        value: 'Montant',
    },
    {
        value: 'Fournisseur',
    },
    {
        value: 'Type',
    },
    {
        value: 'Date de création',
    },
    {
        value: "Date d'écheance",
    },
    {
        value: 'Etat du chéque',
    },
]
export const checksClientColumnsData = [
    {
        value: 'Numéro de telephone',
    },
    {
        value: 'Montant',
    },
    {
        value: 'client',
    },
    {
        value: 'Type',
    },
    {
        value: 'Date de création',
    },
    {
        value: "Date d'écheance",
    },
    {
        value: 'Etat du chéque',
    },
]
export const fournisseursColumnsData = [
    {
        value: 'Nom',
    },
    {
        value: 'Email',
    },
    {
        value: 'N° de Téléphone',
    },
    {
        value: 'RIB',
    },
    {
        value: 'Date de création',
    },
]

export const clientsColumnsData = [
    {
        value: 'Nom',
    },
    {
        value: 'Email',
    },
    {
        value: 'N° de Téléphone',
    },
    {
        value: 'RIB',
    },
    {
        value: 'Date de création',
    },
]

export const paymentChecksData = [
    {
        value: 'Numéro de chéque',
    },
    {
        value: 'Montant',
    },
    {
        value: 'Date',
    },
]